import { motion } from "framer-motion";

export default function SkipToContent() {
  const handleSkip = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const main = document.querySelector("main");
    if (main) {
      main.focus();
      main.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.a
      href="#main-content"
      onClick={handleSkip}
      className="skip-to-content"
      initial={{ y: "-100%" }}
      whileFocus={{ y: 0 }}
      transition={{ duration: 0.2 }}
    >
      Skip to main content
    </motion.a>
  );
}
